import Http from 'common/services/Http';
import { AdditionalDataSearchCriteria } from './models/AdditionalDataSearchCriteria';
import { AdditionalDataDto } from './models/AdditionalDataDto';
import { Paged } from 'api/common/types/Page';
import { AdditionalDataListItemDto } from './models/AdditionalDataListItemDto';


class AdditionalDataService {

    public getList(criteria: AdditionalDataSearchCriteria) {
        return Http.get<Paged<AdditionalDataListItemDto>>('additionaldata', criteria);
    }

    public getByType(type: string) {
        return Http.get<AdditionalDataDto[]>(`additionaldata/get-additional-data-by-type/${type}`);
    }

    public getById(id: string) {
        return Http.get<AdditionalDataDto>('additionaldata/' + id);
    }

    public create(model: AdditionalDataDto) {
        return Http.post<string>('additionaldata', model);
    }
     
    public update(model: AdditionalDataDto) {
        return Http.put('additionaldata', model);
    }

    public remove(model: AdditionalDataDto) {
        return Http.put('additionaldata/deactivate', model);
    }

    public getListingFieldsByType(type: string) {
        return Http.get<AdditionalDataDto[]>(`additionaldata/listing-fields/${type}`);
    }
}

export default new AdditionalDataService();
